// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FF-ShareList {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  list-style: none;
  margin-top: 0.5rem;
  padding: 0;
  max-height: 10rem;
  scrollbar-width: thin;
  overflow: auto;
}

.FF-ShareList-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.125rem 0.5rem;
  border-radius: var(--border-radius-xs, 0.25rem);
  background: var(--color-background-neutral-subtlest, #fff);
}

.FF-ShareList-center {
  display: flex;
  align-items: center;
  height: 2.75rem;
  width: 100%;
}
.FF-ShareList-label {
  width: 100%;
}
.FF-ShareList-permissionWrapper {
  display: flex;
  align-items: center;
  gap: 0.125rem;
}

.FF-ShareList-controlButton {
  min-width: 1.5rem;
  min-height: 1.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/features/FormManagement/components/FormActionModal/ManagePermissions/ShareListItem/ShareList.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,+CAA+C;EAC/C,0DAA0D;AAC5D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB","sourcesContent":[".FF-ShareList {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  list-style: none;\n  margin-top: 0.5rem;\n  padding: 0;\n  max-height: 10rem;\n  scrollbar-width: thin;\n  overflow: auto;\n}\n\n.FF-ShareList-item {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.125rem 0.5rem;\n  border-radius: var(--border-radius-xs, 0.25rem);\n  background: var(--color-background-neutral-subtlest, #fff);\n}\n\n.FF-ShareList-center {\n  display: flex;\n  align-items: center;\n  height: 2.75rem;\n  width: 100%;\n}\n.FF-ShareList-label {\n  width: 100%;\n}\n.FF-ShareList-permissionWrapper {\n  display: flex;\n  align-items: center;\n  gap: 0.125rem;\n}\n\n.FF-ShareList-controlButton {\n  min-width: 1.5rem;\n  min-height: 1.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
